exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dt-picker[data-v-50d972c4] {\n  border: 1px solid rgb(194, 194, 194);\n  padding: 5px 15px;\n}\n.rounded[data-v-50d972c4] {\n  border-radius: 10px;\n}\n.p-holder[data-v-50d972c4] {\n  position: absolute;\n  margin-top: auto;\n  font-size: 14px;\n  -webkit-transition: margin-top .3s, font-size .3s;\n  transition: margin-top .3s, font-size .3s;\n}\n.above[data-v-50d972c4] {\n  margin-top: -15px;\n  font-size: 10px;\n}\n.small[data-v-50d972c4] {\n  padding-top: 1px!important;\n  padding-bottom: 1px!important;\n  height: 27px!important;\n}\n.smaller[data-v-50d972c4] {\n  padding-top: 4px!important;\n  padding-bottom: 4px!important;\n  height: 32px!important;\n}\n.dtime-icon.adjust-small[data-v-50d972c4] {\n  margin-top: 4px;\n}\n.adjust-smaller[data-v-50d972c4] {\n  margin-top: 8px;\n  margin-left: 12px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50d972c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/components/standard/input/InputDateTime.vue
// module id = ffPK
// module chunks = 53